module.exports = __webpack_public_path__ + "img/25.4ff15cc4.jpg";